import { Box, Card } from '@emburse/embark-core';
import styled from '@emotion/styled';
export const OptionCardStyled = styled(Card)({
    '& .MuiCardContent-root': {
        padding: '12px !important'
    }
});
export const OptionCardLabelStyled = styled.div `
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const DateRangesStyled = styled(Box) `
    display: flex;
    gap: 1rem;
    margin-top: ${({ isOptionCard }) => (isOptionCard ? '16px' : '32px')};
    margin-left: ${({ isOptionCard }) => (isOptionCard ? '32px' : 0)};
`;
export const SelectDateRangeFormStyled = styled(Box) `
    display: flex;
    align-items: baseline;
`;
